interface SearchElements {
    bar: string;
    button: string;
    input: string;
    icon: string;
}

interface SearchElementInfo {
    className: string;
    element?: Element;
}

export class SearchBarComponent {
    private searchElements: { [key: string]: SearchElementInfo } = {
        bar: { className: '.search-bar' },
        button: { className: '.search-bar__button' },
        closeButton: { className: '.search-bar__close-button' },
        input: { className: '.search-bar__input' },
        icon: { className: '.search-icon' }
    };

    private isOpen = false;
    private keydownHandler = null;
    private boundKeydownHandler = null;

    constructor() {
        this.findElements();

        this.keydownHandler = (event) => {
            if (!this.isOpen || event.key !== 'Escape') {
                return;
            }
            this.closeSearchbar();
        };
        this.boundKeydownHandler = this.keydownHandler.bind(this);

        this.searchElements.button.element?.addEventListener('click', (e: Event) => {
            e.preventDefault();
            this.searchElements.input.element.classList.toggle('search-bar__input--active');

            this.isOpen = true;
            const input = this.searchElements.bar.element.querySelector('#header-search') as HTMLElement;
            input.focus();
            document.addEventListener('keydown', this.boundKeydownHandler);
        });

        this.searchElements.closeButton.element?.addEventListener('click', (e: Event) => {
            e.preventDefault();
            this.closeSearchbar();
        });
    }

    private findElements(): void {
        (Object.keys(this.searchElements) as (keyof SearchElements)[]).forEach((key: keyof SearchElements) => {
            const className = this.searchElements[key].className;
            const element = document.querySelector(className);
            this.searchElements[key] = { className, element };
        });
    }

    private closeSearchbar() {
        this.searchElements.input.element.classList.toggle('search-bar__input--active');

        this.isOpen = false;
        const element = this.searchElements.bar.element as HTMLElement;
        element.style.zIndex = '';
        document.removeEventListener('keydown', this.boundKeydownHandler);
    }
}
